var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1072.7 613.96h-0.070313l-105.23-268.78s-27.324-68.113-115.05-68.113h-99.168v-53.195c0-14.711-12.625-26.605-28.188-26.605l-253.74 0.003906c-15.562 0-28.188 11.891-28.188 26.605v53.195h-99.168c-87.684 0-115.05 68.113-115.05 68.113l-105.18 268.78c-68.258 0-123.56 55.332-123.56 123.56l-0.10156 293.9h97.055v72.898c0 52.848 42.816 95.676 95.664 95.676s95.664-42.816 95.664-95.676v-72.898h619.49v72.898c0 52.848 42.793 95.676 95.699 95.676 52.801 0 95.629-42.816 95.629-95.676v-72.898h97.055l0.003906-293.91c0-68.23-55.32-123.56-123.55-123.56zm-879.97 293.02c-52.848 0-95.664-42.852-95.664-95.676 0-52.836 42.816-95.688 95.664-95.688 52.848 0 95.664 42.84 95.664 95.688 0 52.824-42.828 95.676-95.664 95.676zm54.219-293.02 77.844-198.97s20.258-50.363 85.164-50.363h188.18 188.14c64.945 0 85.188 50.363 85.188 50.363l77.867 198.97zm756.57 293.02c-52.848 0-95.652-42.852-95.652-95.676 0-52.836 42.793-95.688 95.652-95.688 52.859 0 95.676 42.84 95.676 95.688 0 52.824-42.828 95.676-95.676 95.676z",
    fill: "#01447a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxi);
export default __webpack_public_path__ + "static/media/taxi.8b37536b51be384727236e39c7efd55d.svg";
export { ForwardRef as ReactComponent };